import { render, staticRenderFns } from "./ThePersonalIcon.vue?vue&type=template&id=36e914b9&"
import script from "./ThePersonalIcon.vue?vue&type=script&lang=js&"
export * from "./ThePersonalIcon.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports